import React, { useState } from 'react';
import imgbg from '../Assets/img/dnc_bg.jpg'
import tool1 from '../Assets/hhg_imgs/3d_tools/1.webp'
// import tool2 from '../Assets/hhg_imgs/3d_tools/2.webp'

// import tool3 from '../Assets/hhg_imgs/3d_tools/3.webp'
// import tool4 from '../Assets/hhg_imgs/3d_tools/4.webp'
// import tool5 from '../Assets/hhg_imgs/3d_tools/5.webp'
// import tool6 from '../Assets/hhg_imgs/3d_tools/6.webp'
// import tool7 from '../Assets/hhg_imgs/3d_tools/7.webp'
// import tool8 from '../Assets/hhg_imgs/3d_tools/8.webp'
// import simulation1 from  '../Assets/img/simulation1.mp4'
import dfm1 from '../Assets/img/dfm1.png'
const DesignAndConsultation = () => {
  

 

  return (
 <div class="page-template page-template-elementor_header_footer page page-id-1050 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1050">
      <div id="page" class="jkit-template  site">
        <div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
          <div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
          <div class="elementor-element elementor-element-bdbb4a9 e-flex e-con-boxed e-con e-parent" data-id="bdbb4a9" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
              <div class="e-con-inner">
                <div class="elementor-element elementor-element-2d2b035 e-con-full e-flex e-con e-child" data-id="2d2b035" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                  <div class="elementor-element elementor-element-30e7754 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-heading" data-id="30e7754" data-element_type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="heading.default">
                    {/* <div class="elementor-widget-container">
                      <h5 class="elementor-heading-title elementor-size-default"></h5>		
                    </div> */}
                  </div>
                  <div class="elementor-element elementor-element-641798f elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="641798f" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:200,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_animated_text.default">
                    <div class="elementor-widget-container">
                      <div  class="jeg-elementor-kit jkit-animated-text jeg_module_1050_2_676b7a2b716bd"  data-style="highlighted" data-text="Revolution" data-shape="underline">
                        <h1 class="animated-text">
                        <span class="dynamic-wrapper style-color">
                            <span class="dynamic-text">Desing & </span>
                       <br></br>
                          </span>
                          <span class="normal-text style-color">Consultation
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
                              <path class="style-color"  d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/>
                            </svg>
                          </span>
                          
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div class="elementor-element elementor-element-12b1148 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor" data-id="12b1148" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:300,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="text-editor.default">
                  <div class="dynamic-text">
              Designing Solution, Deliver Result
                </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="elementor-element elementor-element-a5863ef e-flex e-con-boxed e-con e-parent" data-id="a5863ef" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true">
            <div className="e-con-inner">
        <div className="elementor-element elementor-element-c30c61e e-flex e-con-boxed e-con e-child" data-id="c30c61e" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}'>
            <div className="e-con-inner">
                <div className="elementor-element elementor-element-f9e7f13 e-flex e-con-boxed e-con e-child" data-id="f9e7f13" data-element_type="container" data-settings='{"content_width":"boxed"}'>
                    <div className="e-con-inner">
                    
        <img
          src={imgbg}
          alt="Background"
          style={{
            width: '100%',
          
            height: '100%',
            borderRadius: '25px',
            objectFit: 'cover',
            filter: 'brightness(70%)',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: -1,
          }}
        />
        <div style={{ paddingTop: '20%', textAlign: 'center', color: '#fff' }}>
          <h1 className="res-font5" style={{ fontSize: '78px', fontWeight: 800 }}></h1>
        </div>
    
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>

<div class="page-template page-template-elementor_header_footer page page-id-1050 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1050">
	<div id="page" class="jkit-template  site">
		<div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
			<div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
			  <div>
          <style>
                {`
                 
                  @media (max-width: 768px) {
                    .header3 { font-size: 9.2vw !important; }
                    .header4 { font-size: 4.6vw !important; }
                    .res-font5 { font-size: 10vw !important; }
                    .section-title { font-size: 5vw !important; letter-spacing: normal !important; }
                  }
                  @media (min-width: 768px) and (max-width: 1023px) {
                    .desktop_left_margin { margin-left: 40px; }
                  }
                  @media (min-width: 1024px) {
                    .desktop_left_margin { margin-left: 80px; }
                  }
                  .d-row {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 15px;
                  }
                `}
           </style>

      {/* Design for Manufacturability */}
      <section style={{ padding: '0 15%', margin: '30px 0 100px 0' }}>
        {/* <div className="d-row">
          <div style={{ flex: '0 0 41.66%' }}>
            <h2 className="header3" style={{ fontSize: '50px', color: '#000' }}>
              <br />
              <span style={{ fontSize: '40px' }}> </span>
            </h2>
          </div>
          <div style={{ flex: '0 0 58.33%' }}>
            <p style={{ textAlign: 'justify', fontSize: '1.4rem', color: '#000' }}>
              </p>
          </div>
        </div> */}
          <div class="elementor-element elementor-element-869af5c elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="869af5c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h5 class="elementor-heading-title elementor-size-default">Desing For Prototyping</h5>     </div>
                </div>
                {/* <div class="elementor-element elementor-element-8407bdb elementor-widget__width-inherit elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-heading" data-id="8407bdb" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default"> We When Automation Equipment</h2>        </div>
                </div> */}
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title"></h4><p class="feature-list-content">At HHG, our skilled technicians have the ability to transform your napkin sketches into 3D objects. Using cutting-edge design software, we can quickly assess fit and functionality by creating prototypes on our machines.
                 For more extensive engineering endeavors, Whether you require minor adjustments to an existing 3D design or a comprehensive turnkey product development solution, HHG is here to assist.   </p>
                </div>
      </section>

  
<div class="elementor-element elementor-element-3fd02d5 e-flex e-con-boxed e-con e-parent1" data-id="3fd02d5" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
					<div class="e-con-inner">
		<div class="elementor-element elementor-element-836cbbe e-con-full e-flex e-con e-child" data-id="836cbbe" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		<div class="elementor-element elementor-element-b29317c e-con-full e-flex e-con e-child" data-id="b29317c" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">

         <div class="elementor-element elementor-element-db0e5e2 e-con-full e-flex e-con e-child" data-id="db0e5e2" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                <div class="elementor-element elementor-element-869af5c elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="869af5c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h5 class="elementor-heading-title elementor-size-default"> Factors Consider Designing & Engineering</h5>     </div>
                </div>
                <div class="elementor-element elementor-element-8407bdb elementor-widget__width-inherit elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-heading" data-id="8407bdb" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default"> We When Automation Equipment</h2>        </div>
                </div>
                <div class="elementor-element elementor-element-ceb0f99 elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_feature_list" data-id="ceb0f99" data-element_type="widget" data-widget_type="jkit_feature_list.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-feature-list icon-position-left icon-position-left icon-position-left jeg_module_1050_9_676b7a2b8a3d4" ><ul class="feature-list-items shape-circle shape-view-stacked connector-type-classic"><li class="feature-list-item elementor-repeater-item-5c9e9bc">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title"></h4><p class="feature-list-content">To achieve success in custom automation machine design and engineering, HHG abides by a proven, reliable process, one that considers all aspects of a machine’s requirements, including product needs as well as business needs.
                    </p>
                </div>
            </li><li class="feature-list-item elementor-repeater-item-0b496d9">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title"></h4>
                    <p class="feature-list-content">Our goal is to create a product that is successful for years to come, enabling worry-free productivity and long-term profitability. To achieve this, we adhere to the standards of Design for Manufacturability (DFM) throughout our entire product development process.</p>
                </div>
            </li><li class="feature-list-item elementor-repeater-item-de24195">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title"></h4>
                    <p class="feature-list-content">Incorporating DFM standards into our machine design philosophy is a crucial aspect of our approach. It ensures that our machines not only embody innovation and functionality but are also designed with practicality in mind, enabling smooth and efficient production processes.</p>
                </div>
            </li>
            <li class="feature-list-item elementor-repeater-item-de24195">
                <span class="connector"></span>
                <div class="feature-list-icon-box">
                    <div class="feature-list-icon-inner">
                        <span class="feature-list-icon">
                            <i aria-hidden="true" class="fas fa-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title">Here are the principles we take into consideration when designing a machine or system:</h4>
                    <p class="feature-list-content"> Business and Product Planning and Goals<br></br>
       KPIs and Operational Metrics<br></br>
        Understanding Added Value Product Costs at Each Stage<br></br>
         System Flexibility<br></br>
        Contingency Planning for Disruptions or Failures<br></br>
       Automating the Machine Design as Much as Possible<br></br>
        Performance Reporting and Feedback<br></br>
       Serviceability
       And more...</p>
                </div>
            </li>
           
            </ul></div>     </div>
                </div>
                </div>
				</div>
		<div class="elementor-element elementor-element-9ee2b7b e-con-full e-flex e-con e-child" data-id="9ee2b7b" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-6f785b5 elementor-widget elementor-widget-image-carousel" data-id="6f785b5" data-element_type="widget" data-settings="{&quot;slides_to_show&quot;:&quot;1&quot;,&quot;navigation&quot;:&quot;none&quot;,&quot;autoplay_speed&quot;:4000,&quot;autoplay&quot;:&quot;yes&quot;,&quot;pause_on_hover&quot;:&quot;yes&quot;,&quot;pause_on_interaction&quot;:&quot;yes&quot;,&quot;infinite&quot;:&quot;yes&quot;,&quot;effect&quot;:&quot;slide&quot;,&quot;speed&quot;:500}" data-widget_type="image-carousel.default">
				<div class="elementor-widget-container">
					<div class="elementor-image-carousel-wrapper swiper" dir="ltr">
			<div class="elementor-image-carousel swiper-wrapper swiper-image-stretch" aria-live="off">
								<div class="swiper-slide" role="group" aria-roledescription="slide" aria-label="1 of 2">
                  <figure class="swiper-slide-inner">
                    <img decoding="async" class="swiper-slide-image" src={dfm1} alt="" /></figure></div>
                      		</div>
							
									</div>
				</div>
				</div>
				</div>
        
				</div>
					</div>
     
				</div>

      {/* Failure Effective Analysis */}
      {/* <section style={{ padding: '0 10%', margin: '30px 0 100px 0' }}>
        <div className="d-row">
          <div style={{ flex: '0 0 58.33%' }}>
            <video
              src={simulation1}
              style={{
                width: '95%',
                marginLeft: '2.5%',
                height: '80%',
                borderRadius: '25px',
                objectFit: 'cover',
                filter: 'brightness(70%)',
              }}
              autoPlay
              loop
              muted
            />
          </div>
         
          <div class="elementor-element elementor-element-869af5c elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="869af5c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h5 class="elementor-heading-title elementor-size-default">Failure</h5>     </div>
                </div>
                <div class="elementor-element elementor-element-8407bdb elementor-widget__width-inherit elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-heading" data-id="8407bdb" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default"> Effective Analysis</h2>        </div>
                </div>
                <div class="feature-list-content-box">
                    <h4 class="feature-list-title"></h4><p class="feature-list-content">
                    HHG offers advanced FEA solution and consulting services. Whether it’s stress analysis, fluid dynamics, or virtual prototyping, our simulations optimize performance and reduce development time.
          
                    </p>
                </div>
        </div>
      </section> */}

      {/* 3D Tools */}
      {/* <section style={{ padding: '0 10%', margin: '30px 0 40px 0', textAlign: 'center' }}>
        <h3 className="header3" style={{ fontSize: '60px', color: '#000', fontWeight: 700, display: 'inline' }}>
          3D-Tools
        </h3><br></br>
       
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px' }}>
          <img src= {tool1}alt="Tool 1" style={{ width: '100%', height: 'auto' }} />
          <img src= {tool2} alt="Tool 2" style={{ width: '100%', height: 'auto' }} />
          <img src= {tool3} alt="Tool 3" style={{ width: '100%', height: 'auto' }} />
          <img src= {tool4} alt="Tool 4" style={{ width: '100%', height: 'auto' }} />
          <img src= {tool5} alt="Tool 5" style={{ width: '100%', height: 'auto' }} />
          <img src= {tool6} alt="Tool 6" style={{ width: '100%', height: 'auto' }} />
          <img src= {tool7} alt="Tool 7" style={{ width: '100%', height: 'auto' }} />
          <img src= {tool8} alt="Tool 8" style={{ width: '100%', height: 'auto' }} />
        </div>
      </section> */}

      </div>
        </div>
    </div>
    </div>

    </div>    </div>    </div>    </div>    </div>   
  );
};

export default DesignAndConsultation;